import React, { useEffect, useState } from 'react';
import { client } from '../api/Api';

export default function MyPrices() {
  const [items, setItems] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    client.get('/my-prices').then(({ data }) => setItems(data)).catch(() => setError('Reikia prisijungti.'));
  }, []);

  if (error) return <div style={{ maxWidth: 900, margin: '20px auto' }}>{error}</div>;

  return (
    <div style={{ maxWidth: 900, margin: '20px auto' }}>
      <h2>Mano įkeltos kainos</h2>
      {items.length === 0 && <div>Dar nėra įkeltų kainų.</div>}
      <ul>
        {items.map(p => (
          <li key={p.id}>
            <span>{p.date}</span>{' '}
            <strong>{p.value}</strong>{' '}
            {p.product && p.product.name ? (<span>- {p.product.name}</span>) : null}
          </li>
        ))}
      </ul>
    </div>
  );
}
